






















import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import ScrollableTableCell from "./ScrollableTableCell.vue";
import { Row, Cell, Header } from "../../../../domain/system/table";

@Component({
  components: {
    ScrollableTableCell,
  },
})
export default class ScrollableTableRow extends Mixins() {
  @Prop()
  row: Row;

  @Prop({ default: false })
  isTitle: boolean;

  @Prop({ default: false })
  isFilter: boolean;

  @Prop()
  headers: Header[];

  @Prop()
  columnsCells: string[][];

  getCellWidth(index: number): number {
    const header = this.headers[index];
    if (!header) {
      console.warn("invalid index!!! index: " + index);
      return null;
    }
    return (!!header.width && header.width > 0)
      ? header.width
      : null;
  }

  getCellVisible(index: number): boolean {
    const header = this.headers[index];
    return !header || header.isVisible;
  }

  getColumnCells(index: number): string[] {
    return this.columnsCells && this.columnsCells[index]
      ? this.columnsCells[index]
      : [];
  }

  getInitialFilterText(index: number): string {
    if (!this.isFilter) { return ""; }
    const header = this.headers[index];
    return header.filterText;
  }

  onClicked(cell: Cell, isWithCtrl: boolean): void {
    this.$emit("rowClicked", this.row, cell, isWithCtrl);
  }

  onDoubleClicked(cell: Cell): void {
    this.$emit("rowDoubleClicked", this.row, cell);
  }

  onCellWidthChanged(index: number, width: number): void {
    const header = this.headers[index];
    if (!header) {
      console.warn("invalid index!!! index: " + index);
      return;
    }
    if (width > header.width) {
      header.width = width;
    }
  }

  onFilterTextChanged(index: number, text: string): void {
    this.$emit("filterTextChanged", index, text);
  }

  onFilterItemsChanged(index: number, texts: string[]): void {
    this.$emit("filterItemsChanged", index, texts);
  }

  @Emit("enterKeyDown")
  onEnterKeyDown(index: number): void {}
}
